import * as React from 'react';

import type {Lead as LeadFragment} from 'nutshell-graphql-types';

import {LeadCloseDate} from '../../shared/components/lead-close-date';
import {LeadConfidence} from '../../shared/components/lead-confidence';
import {LeadOpenedBy} from '../../shared/components/lead-opened-by';
import {LeadOpenedOn} from '../../shared/components/lead-opened-on';
import {LeadTerritory} from '../../shared/components/lead-territory';

import styles from './lead-header-left.module.css';

type Props = {
    lead: LeadFragment;
    onUpdateLeadConfidence: (arg1: number) => void;
    onUpdateLeadCreatedDate: (arg1?: Date | null | undefined) => void;
    onUpdateLeadDueDate: (arg1?: Date | null | undefined) => void;
    onUpdateLeadClosedDate: (arg1?: Date | null | undefined) => void;
};

export function LeadSubheaderContainer(props: Props) {
    return (
        <div className={styles['subheader-container']}>
            <LeadOpenedBy lead={props.lead} />
            <LeadOpenedOn
                createdTime={props.lead.createdTime}
                onUpdateLeadCreatedDate={props.onUpdateLeadCreatedDate}
            />
            <LeadCloseDate
                lead={props.lead}
                onUpdateLeadDueDate={props.onUpdateLeadDueDate}
                onUpdateLeadClosedDate={props.onUpdateLeadClosedDate}
            />
            {/* Hack - this is styled as the 4th child in CSS, check before moving! */}
            <LeadConfidence
                // @ts-expect-error
                lead={props.lead}
                value={props.lead.confidence}
                onUpdate={props.onUpdateLeadConfidence}
            />
            {props.lead.territory && <LeadTerritory territory={props.lead.territory} />}
        </div>
    );
}
